// components/dialogs/FilePreviewDialog.tsx
import { Dialog, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  open: boolean;
  src: string | null | undefined;
  filename: string | null | undefined;
  onClose: () => void;
};

const FilePreviewDialog = ({ open, src, filename, onClose }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          color: "white",
          backgroundColor: "rgba(0,0,0,0.5)",
          "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
          zIndex: 10,
        }}
      >
        <CloseIcon fontSize="large" />
      </IconButton>
      {src && (
        <Box sx={{ width: "100%", height: "100%", backgroundColor: "black" }}>
          <Box
            component="iframe"
            src={src}
            title={filename ? filename : "File Preview"}
            sx={{
              width: "100%",
              height: "100%",
              border: "none",
              backgroundColor: "white",
            }}
          />
        </Box>
      )}
    </Dialog>
  );
};

export default FilePreviewDialog;
